import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './AlertBar.styles.js';
import {
  CheckmarkCircle as CheckmarkCircleIcon,
  ExclamationCircle as ExclamationCircleIcon,
  ExclamationTriangle as ExclamationTriangleIcon,
  InfoCircle as InfoCircleIcon,
} from '../icons/Icons.jsx';

const AlertBar = ({
  action,
  actionMessage,
  alertType,
  animated,
  children,
  className,
  style,
  suppressAlertType
}) => (
  <div
    className={classnames(className, styles.alertBar[alertType], { [styles.animated]: animated })}
    style={style}
  >
    <div className={styles.alertContainer}>
      {renderIcon(alertType, style.color ? {fill: style.color} : undefined)}
      <span className={styles.alertMessage}>
        {!suppressAlertType && <span className={styles.alertType}>{alertType}: </span>}
        {children}
      </span>
    </div>
    <div className={styles.actionContainer}>
      {renderAction(action, actionMessage)}
    </div>
  </div>
);

const renderIcon = (alertType, style) => {
  switch (alertType) {
  case 'error':
    return <ExclamationCircleIcon className={styles.icon[alertType]} style={style} />;
  case 'warning':
    return <ExclamationTriangleIcon className={styles.icon[alertType]} style={style} />;
  case 'success':
    return <CheckmarkCircleIcon className={styles.icon[alertType]} style={style} />;
  case 'info':
    return <InfoCircleIcon className={styles.icon[alertType]} style={style} />;
  }
};

const renderAction = (action, actionMessage) => {
  if (!action) {
    return;
  }

  if (React.isValidElement(action)) {
    return action;
  }

  if (!actionMessage) {
    return;
  }

  if (typeof action === 'string') {
    return <a href={action} rel="noopener" target="_blank">{actionMessage}</a>;
  }
  else {
    return <a onClick={action}>{actionMessage}</a>;
  }
};

AlertBar.propTypes = {
  action: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.element]),
  actionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  alertType: PropTypes.oneOf(['success', 'info', 'warning', 'error']).isRequired,
  animated: PropTypes.bool,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  suppressAlertType: PropTypes.bool,
};

AlertBar.defaultProps = {
  animated: false,
  style: {},
  suppressAlertType: false,
};

export default AlertBar;
